/** Statsig gate name for org-scoped unified home rollout (user-level). */
export const ORG_SCOPED_HOME_STATSIG_GATE = 'org-scoped-home';

/**
 * Org IDs that bypass the Statsig gate and product feature flag, unconditionally
 * enabling the org-scoped home experience for any user with a program membership
 * in that org. Used for early-access partners and testing orgs.
 */
export const ORG_SCOPED_HOME_OVERRIDE_ORG_IDS: ReadonlySet<string> = new Set([
  '5NMdIbtBNpCsgK6sSnM7Zg',
  'JKAzyiy3MqOTbZiJKuMpMQ',
  'mBGGjRIvN-mzJZ1YpQVnmw', // unified-home-testing
  'AAF5FgTmRq2GzxwgweDj1g', // hooli
]);
